import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import CommunityApi from "../../../api/community.api";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";

const CommunityPost = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedCategory, setSelectedCategory] = useState("전체");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  // mounted
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getPostList();
    getCategory();
  }, [location, selectedCategory]);

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [categoryList, setCategoryList] = useState([]);
  const [postList, setPostList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getPostList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };

      if (selectedCategoryId) {
        data.communityCategoryId = selectedCategoryId;
      }

      let responseData = (await CommunityApi.getPost(data)).data.data;

      setPostList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const getCategory = async () => {
    try {
      let responseData = (await CommunityApi.getCategory({ size: 1000 })).data
        .data.content;

      setCategoryList(responseData);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const isAllCheck = useMemo(() => {
    const checkedList = postList.filter((item) => item.checked);
    return checkedList.length !== 0 && checkedList.length === postList.length;
  }, [postList]);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await CommunityApi.delPost(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getPostList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const [categoryBoxOpen, setCategoryBoxOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>게시글 관리</TableTitle>
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <div style={{ position: "relative", width: "120px" }}>
                <SelectBoxWrapper
                  onClick={() => {
                    setCategoryBoxOpen(!categoryBoxOpen);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <PretendardText
                    style={{
                      color: "#808991",
                      fontSize: "15px",
                      fontWeight: "400",
                      lineHeight: "21.25px",
                    }}
                  >
                    {selectedCategory || "카테고리"}
                  </PretendardText>
                  <img
                    src="/assets/admin/icons/ico_select_arrow_down.svg"
                    alt=""
                  />
                </SelectBoxWrapper>
                {categoryBoxOpen ? (
                  <SubMenuWrapper>
                    <SubMenuTextWrapper
                      onClick={() => {
                        setSelectedCategory("전체");
                        setSelectedCategoryId("");
                        setCategoryBoxOpen(false);
                      }}
                    >
                      <PretendardText
                        style={{
                          color: "#262C31",
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                        }}
                      >
                        전체
                      </PretendardText>
                    </SubMenuTextWrapper>
                    {categoryList.map((item, index) => {
                      return (
                        <SubMenuTextWrapper
                          key={index}
                          onClick={() => {
                            setSelectedCategory(item.title);
                            setSelectedCategoryId(item.id);
                            setCategoryBoxOpen(false);
                          }}
                        >
                          <PretendardText
                            style={{
                              color: "#262C31",
                              fontSize: "15px",
                              fontWeight: "500",
                              lineHeight: "21.5px",
                            }}
                          >
                            {item.title}
                          </PretendardText>
                          {/* {partnerInfo.region === item.title ? (
                            <img
                              src="/assets/admin/icons/ico_select_checked.svg"
                              alt=""
                            />
                          ) : null} */}
                        </SubMenuTextWrapper>
                      );
                    })}
                  </SubMenuWrapper>
                ) : null}
              </div>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.community_post}?page=1&keyword=${encodeURIComponent(
                        keyword
                      )}`,
                      {
                        replace: true,
                      }
                    );
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.community_post}?page=1&keyword=${encodeURIComponent(
                      keyword
                    )}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              <DelBtn
                text={"선택항목 삭제"}
                onClick={() => {
                  const delList = postList.filter((item) => item.checked);
                  if (delList.length <= 0) {
                    return;
                  }
                  setDelIdList(delList.map((item) => item.id));
                  setDeleteModalOpen(true);
                }}
              />
            </TableSearchBtn>
          </TableTop>

          <Table>
            <colgroup>
              <col width="90px" />
              <col width="137px" />
              <col width="256px" />
              <col width="71px" />
              <col width="68px" />
              <col width="140px" />
              <col width="91px" />
              <col width="73px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPostList(
                          postList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setPostList(
                          postList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText>카테고리</TableText>
                </Th>
                <Th>
                  <TableText>제목</TableText>
                </Th>
                <Th>
                  <TableText>조회수</TableText>
                </Th>
                <Th>
                  <TableText>댓글 수</TableText>
                </Th>
                <Th>
                  <TableText>작성일</TableText>
                </Th>
                <Th>
                  <TableText>삭제하기</TableText>
                </Th>
                <Th>
                  <TableText>상세보기</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {postList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "59px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setPostList([...postList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.communityCategory?.title}</TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          width: "200px",
                        }}
                      >
                        {item.title}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>{item.viewCount}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.commentCount}</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment.utc(item.createdAt).format("YYYY/MM/DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableDelBtn
                        onClick={() => {
                          setPostList([...postList]);
                          const delList = [item];
                          setDelIdList(delList.map((item) => item.id));
                          setDeleteModalOpen(true);
                        }}
                      />
                    </Td>

                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(route.community_post_detail + `/${item.id}`);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.community_post}
            queryString={`keyword=${encodeURIComponent(
              searchParams.get("keyword") || ""
            )}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};
export default CommunityPost;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 120px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid #adb4ba;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 120px;
  max-height: 200px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);
  position: absolute;
  top: 50px;
  right: 0;
  padding: 10px;
  overflow-y: auto;
  z-index: 5;

  &::-webkit-scrollbar {
    width: 15px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바의 색상 */
    border-radius: 9px;
    background-clip: padding-box;
    border: 6px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    background-color: #f2f4f5;
  }
`;
